<template>
<div class="setting">

<el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ name: 'products' }">{{$t('product.myProduct')}}</el-breadcrumb-item>
  <el-breadcrumb-item :v-if="this.product">{{this.product.name}} | {{$t('allDomain.config')}}</el-breadcrumb-item>
</el-breadcrumb>

<div class="tab-content">
<el-tabs v-model="category" @tab-click="handleClick">
    <el-tab-pane lazy :label="$t('product.cache')" name="cache">
      <CacheSetting  :pid="this.pid" />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('product.strategy')" name="strategy">
      <CeNueSetting :pid="this.pid" />
    </el-tab-pane>    
  </el-tabs>
</div>

</div>
</template>

<script>
import { productDetail } from '@/service/requestRes';
import CacheSetting from '@/views/products/CacheSetting.vue';
import CeNueSetting from '@/views/products/CeNueSetting2.vue';

/* eslint-disable */
export default {
  components: {
    CacheSetting,
    CeNueSetting,
    // prodConfig,
  },  
  data() {
    return {
        pid: this.$route.params.pid,
        product: {name: null},
        category: this.$route.params.category, 
    };
  },
  computed: {
  },
  mounted() {
    // this.pid = this.$route.params.pid;
    this.getProductDetail(this.pid);
  },
  methods: {
    getProductDetail() {
      productDetail(
          this.pid
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.product = data;
            window.console.debug(data);
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    handleClick() {
    },
  },
};
</script>


<style lang="scss" scoped>

.setting {
  background-color: white;
  padding: 24px;
}
.tab-content {
  margin-top: 24px;
  ::v-deep .el-tabs__item.is-active {
      color: #2664FF;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #2664FF;
  }
}
</style>
